<template>
  <div>
    <el-row :gutter="20">
      <el-col
        :lg="{span:'12' ,offset:'0'}"
        :md="{span:'12' ,offset:'0'}">
        <el-row :gutter="20">
          <el-col
          :lg="{span:'24' ,offset:'0'}"
          :md="{span:'24' ,offset:'0'}">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="ค้นหา Order Number, Tracking Number"
              v-model="orderTexts" ></el-input>
          </el-col>
      </el-row>
    <el-row :gutter="20">
        <el-col
        :md="{span:'15' ,offset:'0'}"
      >
      <el-button
          type="primary"
          :loading="searchLoading"
          @click="searchOrders"
          style="margin-top:10px;width:100%"
        >Search</el-button>

        </el-col>
        <el-col
        :md="{span:'9' ,offset:'0'}"
      >

        <el-button
        type="primary"
          @click="exportExcel"
          style="margin-top:10px;width:100%"
          :disabled="!showCard"
        >Export Excel Log</el-button>
        </el-col>
      </el-row>

      </el-col>

      <el-col
        :lg="{span:'12' ,offset:'0'}"
        :md="{span:'12' ,offset:'0'}"
      >
        <div style="font-size:20px">
          <el-row>
            <el-col
              :span="11"
              class="text-md-right"
            >จำนวน Order Number ที่ค้นหา</el-col>
            <el-col :span="1">:</el-col>
            <el-col
              :span="12"
              class="text-md-left"
            ><b>{{orderCountSearch}}</b></el-col>
          </el-row>
          <el-row>
            <el-col
              :span="11"
              class="text-md-right"
            >จำนวน Order Number ที่เจอ</el-col>
            <el-col :span="1">:</el-col>
            <el-col
              :span="12"
              class="text-md-left"
            ><b style="color:green;">{{orderCountResult}}</b></el-col>
          </el-row>
          <el-row>
            <el-col
              :span="11"
              class="text-md-right"
            >Order Number ที่ไม่พบ </el-col>
            <el-col :span="1">:</el-col>
            <el-col
              :span="12"
              class="text-md-left"
            ><b style="color:#c21e56;">{{OrderNumberFailMatch?OrderNumberFailMatch:'-'}}</b></el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row
      :gutter="20"
      v-if="showCard"
    >
      <el-col :span="24">
        <el-card shadow="never">
          <el-checkbox v-model="checkAll" label="เลือกทั้งหมด" border @change="checkAllOrder"  style="margin-right:10px;margin-left:10px"></el-checkbox>
          <el-button
           type="primary"
          @click="createShipment"
          :disabled="orderListCreateShipment >= 0"
        >Create Shipment</el-button>
          <el-button
           type="warn"
          style="background-color: #E6A23C; border-color: #E6A23C; color: white"
          :disabled="orderListCreateShipment >= 0"
          @click="onPullShipmentStatus()"
        >ดึงสถานะล่าสุด</el-button>
        <br><br>
          <el-col
            :lg="{span:'6' ,offset:'0'}"
            :md="{span:'12' ,offset:'0'}"
            v-for="item in tableData"
            :key="item.key"
          >
            <el-card
              shadow="hover"
              class="card-body"
            >
              <b>Order Number : {{item.orderNumber}}
                <input
                  type="checkbox"
                  :id="item.orderNumber"
                  :value="{orderNumber:item.orderNumber,shopId:item.shopId,shopName:item.shop.name,courierId:item.courierId, trackingNumber: item.trackingNumber}"
                  v-model="orderListCreateShipment"
                >

              </b>
              <br>
              <div
                class="cursor-card"
                @click="orderDetail(item.orderNumber)"
              >
                <hr class="hr-style">
                Tracking Number : {{item.trackingNumber ? item.trackingNumber : '-'}}<br>
                <!-- <span v-html="getLink(item.trackingNumber,item.courierId)"></span> <br> -->
                <!-- created_at : {{ this.$dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}} <br> -->
                Courier : {{getCourier(item.courierId)}} <br>
                Status : <span v-html="checkStatus(item.status,item.deletedAt)"></span><br>
                <span v-if="item.deletedAt">Deleted at :{{ $dayjs(item.deletedAt).format('YYYY-MM-DD HH:mm:ss')}}<br></span>
                Created at : {{ $dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}} <br>
                <hr
                  class="hr-style"
                  style="margin-bottom: 5px;"
                >
                Shop Name : {{item.shop.name}}<br>
                <hr
                  class="hr-style"
                  style="margin-bottom: 5px;"
                >
                ชื่อ : {{item.shippingName}} <br>
                เบอร์โทร : {{item.shippingPhoneNumber}}<br>
                <span class="break-word"> ที่อยู่ : {{item.shippingAddress}}</span> <br>{{item.shippingDistrict}} {{item.shippingSubDistrict}}
                {{item.shippingProvince}} {{item.shippingZipcode}} <br>
                <hr
                  class="hr-style"
                  style="margin-bottom: 5px;"
                >
                Order Price : <b>{{item.netPrice | currency}} ฿</b>
                <el-table
                  :data="item.products"
                  height="250"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="name"
                    label="สินค้า"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="quantity"
                    label="จำนวน"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="price"
                    label="ราคา"
                  >
                  </el-table-column>

                </el-table>
              </div>
            </el-card>

          </el-col>
        </el-card>
      </el-col>
    </el-row>
    <create-shipment-search
      :dialogShow="dialogCreateShipment"
      @closeModal="dialogCreateShipment = false"
      :CrateShipmentDetail="listOrderCreate"/>
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import payment from '@/mixins/paymentUtility.js'
import mixinExcel from '@/mixins/exportExcel.js'
import createShipmentSearch from '@/components/LogOrder/DialogCreateShipmentSearch'
export default {
    name: 'LogOrder',
    components: {
        createShipmentSearch
    },
    mixins: [mixinExcel, payment],
    data () {
        return {
            dialogCreateShipment: false,
            listOrderCreate: [],
            orderListCreateShipment: [],
            infoDialogVisible: false,
            historyDialogVisible: false,
            csDialogVisible: false,
            financeDialogVisible: false,
            searchLoading: false,
            orderTexts: ``,
            viewOrderInfoData: {},
            viewOrderFinanceData: {},
            tableData: [],
            orderCountSearch: 0,
            orderCountResult: 0,
            findMatch: [],
            OrderNumberFailMatch: '',
            showCard: false,
            checkAll: false
        }
    },
    methods: {
        async onPullShipmentStatus () {
            try {
                this.$loading()
                const params = {
                    orders: this.orderListCreateShipment.map(order => {
                        return {
                            orderNumber: order.orderNumber,
                            trackingNumber: order.trackingNumber,
                            courierId: order.courierId
                        }
                    }) }
                let response = await fgApi.courier.pullStatusOrderList(params)
                if (response.success) {
                    this.$message.success('ดึงสถานะล่าสุดสำเร็จ!!')
                    this.searchOrders()
                }
                this.$loading().close()
            } catch (error) {
                console.error(error)
            }
        },
        async searchOrders () {
            this.checkAll = false
            this.orderListCreateShipment = []
            this.orderListCreateShipment = []
            this.OrderNumberFailMatch = ''
            this.showCard = false
            this.searchLoading = true
            if (this.orderTexts) {
                let orderNumbers = this.orderTexts.split('\n')
                orderNumbers = orderNumbers.map(e => e.trim())
                orderNumbers = orderNumbers.filter(e => { if (e !== '') { return e } })
                // if (orderNumbers[orderNumbers.length - 1] === '') {
                //     orderNumbers.pop()
                // }
                // console.log(orderNumbers)
                this.orderCountSearch = orderNumbers.length
                let data = await fgApi.order.getOrderByOrderNumbers({
                    order_numbers: orderNumbers
                })
                // console.log(data)
                if (data.success === true) {
                    if (data.data.length > 0) {
                        this.showCard = true
                    }
                    this.tableData = data.data
                    this.orderCountResult = data.data.length
                    if (orderNumbers.length !== data.data.length) {
                        let newArr = []
                        orderNumbers.forEach(e => {
                            let check = []
                            if (data.data.length > 0) {
                                for (let s in data.data) {
                                    if (e === data.data[s].orderNumber) {
                                        check.push(true)
                                    } else if (e === data.data[s].trackingNumber) {
                                        check.push(true)
                                    } else {
                                        check.push(false)
                                    }
                                    if (parseInt(s) === data.data.length - 1) {
                                        let find = check.find(f => f === true)
                                        if (!find) {
                                            newArr.push(e)
                                        }
                                    }
                                }
                            } else {
                                newArr = orderNumbers
                            }
                        })
                        this.OrderNumberFailMatch = newArr.join(', ')
                    }
                }
            } else {
                this.orderCountSearch = 0
            }
            this.searchLoading = false
        },

        async exportExcel () {
            // console.log(this.tableData)

            this.$loading()
            let excelHead = this.excelOrderHeader

            this.tableData.forEach(order => {
                // console.log(order)
                let status = `${this.getOrderStatus(order.status)} ${
                    order.deletedAt ? '(ลบ)' : ''
                }`
                let arrData = [
                    order.orderNumber,
                    order.trackingNumber,
                    order.shippingName,
                    order.shippingPhoneNumber,
                    order.shippingPhoneNumberSec,
                    order.shippingAddress,
                    order.shippingSubDistrict,
                    order.shippingDistrict,
                    order.shippingProvince,
                    order.shippingZipcode,
                    order.shippingTag,
                    this.getCourier(order.courierId),
                    this.getPaymentType(order.paymentType),
                    order.netPrice,
                    order.deliveryCost,
                    this.calculateServiceDeliveryCost(order, order.shop),
                    order.actualWeight,
                    order.dimWeight,
                    this.$dayjs(order.createdAt).format('YYYY-MM-DD HH:mm:ss'),
                    order.note,
                    order.paymentDate
                        ? this.$dayjs(order.paymentDate).format('YYYY-MM-DD HH:mm:ss')
                        : '',
                    this.getBank(order.paymentBank),
                    order.paymentAmount,
                    this.$dayjs(order.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
                    status,
                    this.getPurchaseChannel(order.purchaseChannel),
                    order.employeeId
                        ? `${order.employeeFirstName} ${order.employeeLastName}`
                        : `${order.userFirstName} ${order.userLastName}`,
                    this.getPrintKeyword(order.isPrint),
                    order.userEmail,
                    order.userCode,
                    order.shop.name,
                    order.shop.shopId,
                    order.shop.shopCode,
                    order.agent.agentId
                        ? order.agent.name
                        : '-'
                ]
                // console.log(arrData)
                excelHead.push(arrData)
            })
            this.saveExcel(excelHead, 'export_LoadOrder_search')
            this.$loading().close()
        },
        orderDetail (val) {
            let route = this.$router.resolve({
                path: `/oms/logOrder/LogOrderDetail`,
                query: { orderId: val }
            })
            window.open(route.href, '_blank') // New tab
        },
        checkStatus (status, del) {
            // {{getOrderStatus(item.status)}}
            let statusName = this.getOrderStatus(status)
            if (del) {
                return `<span style="color:red;">${statusName} (ลบ)<span>`
            } else {
                return `${statusName}`
            }
        },
        createShipment () {
            let listOrder = []
            // เช็คไอดีขนส่ง 4(flash) และ 6(thaipost) และ เช็คเลข Tracking number TH, EA, EB ถ้าตรงเงื่อนไข จะ Filter ออก
            const orderList = this.orderListCreateShipment.filter(order =>
                !(order.courierId === 4 && order.trackingNumber.slice(0, 2) === 'TH') &&
                !(order.courierId === 6 && (order.trackingNumber.slice(0, 2) === 'EA' || order.trackingNumber.slice(0, 2) === 'EB'))
            )
            var outObject = orderList.reduce(function (a, e) {
                let estKey = e['shopId'];
                (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e)
                return a
            }, {})
            Object.values(outObject).forEach(e => {
                let orders = e.map(e => e.orderNumber)
                let courierId = e.map(e => e.courierId)
                let trackingNumber = e.map(e => e.trackingNumber)
                listOrder.push({
                    orderNumbers: orders,
                    shopId: e[0].shopId,
                    shopName: e[0].shopName,
                    courierId: courierId,
                    trackingNumber: trackingNumber
                })
            })
            this.listOrderCreate = listOrder
            this.dialogCreateShipment = !this.dialogCreateShipment
        },
        checkAllOrder () {
            if (this.checkAll) {
                this.orderListCreateShipment = []
                this.tableData.forEach(e => {
                    let orderDetail = {
                        orderNumber: e.orderNumber,
                        shopId: e.shopId,
                        shopName: e.shop.name,
                        courierId: e.courierId,
                        trackingNumber: e.trackingNumber
                    }
                    this.orderListCreateShipment.push(orderDetail)
                })
            } else {
                this.orderListCreateShipment = []
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.searchButton {
  width: 75%;
}
.createShipButton {
  color: white;
  background-color: teal;
  border-color: teal;
  margin-left: 10px;
}
.exportButton {
  color: white;
  background-color: teal;
  border-color: teal;
  width: 20%;
}
.el-button.is-disabled {
  background-color: #60a2a2;
  border-color: #60a2a2;
}
.el-button--danger {
  background-color: teal;
  border-color: teal;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
hr {
  margin-bottom: 20px;
}
a {
  color: #409eff;
  text-decoration: none;
}
.el-card {
  font-size: 14px;
  margin-bottom: 20px;
  text-align: left;
}
.card-body {
  height: 600px;
}
.hr-style {
  border-top: 1px solid #ebeef5;
}
.break-word {
  overflow-wrap: break-word;
}
.cursor-card {
  cursor: pointer;
}
input[type="checkbox"]{
  width: 20px; /*Desired width*/
  height: 20px; /*Desired height*/
}
</style>
